<template>
  <article class="about-content">
    <!-- DATA 数据一览：六个关键数字 -->
    <div class="band-head">
      <span class="band-num">DATA</span>
      <h2>数据一览</h2>
      <span class="rule"></span>
    </div>
    <p class="band-lead">用六个关键数字，快速了解动态时序科技。</p>
    <div class="metrics-grid">
      <div class="metric" v-for="item in metrics" :key="item.label">
        <b>{{ item.value }}</b>
        <span class="metric-label">{{ item.label }}</span>
        <p>{{ item.desc }}</p>
      </div>
    </div>

    <!-- 公司简介 -->
    <div class="section-head about-sec-head">
      <div class="eyebrow">Our Story</div>
      <h2>让商业数据更有序、更可用</h2>
    </div>
    <div class="grid grid-2">
      <div class="card" v-for="item in story" :key="item.title">
        <h3>{{ item.title }}</h3>
        <p>{{ item.body }}</p>
      </div>
    </div>

    <!-- 发展历程 -->
    <div class="section-head about-sec-head">
      <div class="eyebrow">Milestones</div>
      <h2>发展历程</h2>
    </div>
    <div class="timeline">
      <div class="timeline-item" v-for="item in milestones" :key="item.year">
        <b>{{ item.year }}</b>
        <p>{{ item.text }}</p>
      </div>
    </div>

    <!-- 企业价值观 -->
    <div class="section-head about-sec-head">
      <div class="eyebrow">Values</div>
      <h2>企业价值观</h2>
    </div>
    <div class="grid grid-3">
      <div class="card value-card" v-for="item in values" :key="item.title">
        <div class="icon">{{ item.icon }}</div>
        <h3>{{ item.title }}</h3>
        <p>{{ item.text }}</p>
      </div>
    </div>
  </article>
</template>

<script>
/* 关于我们（原 /aboutUs/case1 的简介与联系方式）
   内容按 website-handoff/about.html 重做：DATA 数据一览 6 项 + 公司简介 + 发展历程 + 企业价值观。
   联系方式（电话 / 邮箱 / 地址）由 handoff 口径承接：邮箱与地址保留在页脚与「联系我们」页，
   旧版电话 13522760991 按 M1 的页脚口径不再出现。 */
export default {
  name: 'aboutUsCase1',
  data() {
    return {
      metrics: [
        { value: '¥500万+', label: '融资', desc: '2021 年成立于北京海淀，专注商业数据监控及调用服务。' },
        { value: '200+', label: '标准/可定制化接口', desc: '覆盖工商、司法风险、经营风险、知识产权、关联关系等 17 大数据分类，支持按需组合与字段级定制。' },
        { value: '100+', label: '企业终端用户', desc: '某生物医药公司、某研究机构、某政务园林机构、某信用科技公司、某水务集团等。' },
        { value: '20+', label: '覆盖行业', desc: '生物医药、标准研究、政务园林、金融信用、水务能源、智能制造等。' },
        { value: '17+', label: '覆盖省市', desc: '北京、上海、广东、四川、山东、福建、湖北等省级行政区。' },
        { value: '4亿+', label: '覆盖主体数量', desc: '数据覆盖主体 4亿+，司法信息条数约 7.5亿，支撑尽调、风控与关联核查等场景。' }
      ],
      story: [
        {
          title: '我们的使命',
          body: '帮助企业以最低的门槛完成数据的采集、监控与调用，让每一个业务决策都有数据支撑。我们服务生物医药、标准研究、政务园林、金融信用等行业，为某生物医药公司、某研究机构等 100+ 企业终端用户提供稳定可靠的数据基础设施。'
        },
        {
          title: '我们的团队',
          body: '核心成员来自国内一线互联网与数据库厂商，深耕时序数据处理、大数据平台与 API 网关领域多年。工程师文化浓厚，追求简洁可靠的技术方案与极致的服务响应。'
        }
      ],
      milestones: [
        { year: '2021', text: '公司在北京海淀成立，确立商业数据监控及调用服务的主营方向。' },
        { year: '2024', text: '获评国家高新技术企业，荣获中关村管委会筑基项目奖金。' },
        { year: '2025', text: '获评北京市创新型中小企业、A 级纳税人，数据覆盖主体数量达 4亿+。' },
        { year: '2026', text: '司法信息条数累计至约 7.5亿，客户覆盖 20+ 行业、17+ 省市。' }
      ],
      values: [
        { icon: '🎯', title: '客户为先', text: '客户的业务成功是衡量我们工作的唯一标准。' },
        { icon: '🛡️', title: '数据可信', text: '安全、准确、及时，是数据服务不可妥协的底线。' },
        { icon: '🚀', title: '持续精进', text: '保持技术好奇心，用更好的产品回应每一次信任。' }
      ]
    }
  },
  mounted() {
    this.$store.commit('setAboutIndex', 0)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/aboutUs/caseChild/case1.vue